
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    displayBack: Boolean,
    firstPanel: Boolean,
    helpTextLeft: Boolean,
    titleText: String,
    helpText: String,
  },

  emits: ['onBack'],

  methods: {
    goBack() {
      this.$emit('onBack');
    },
  },
});
